import React from 'react'

const ContactLinks = () => {
  return (
    <>
    
                    <a href=""><i class="zmdii zmdi zmdi-facebook"></i></a>
                    <a href="https://instagram.com/utkar5hh?igshid=ZDdkNTZiNTM="><i class="zmdii zmdi zmdi-instagram"></i></a>
                    <a href="https://www.linkedin.com/in/utkarshg494"><i class="zmdii zmdi zmdi-linkedin"></i></a>
                    <a href=""><i class="zmdii zmdi zmdi-email"></i></a>
                    <a href=""><i class="zmdii zmdi zmdi-google"></i></a>
    
    
    
    </>
  )
}

export default ContactLinks